import * as login from "./moudules/login";
import * as menu from "./moudules/menu";
import * as authorityManagement from "./moudules/authorityManagement";
import * as informationMaintenance from "./moudules/informationMaintenance";
import * as classManagement from "./moudules/classManagement";
import * as memberManagement from "./moudules/memberManagement";
import * as roleManagement from "./moudules/roleManagement";
import * as subjectManagement from "./moudules/subjectManagement";
import * as jobStatistics from "./moudules/jobStatistics";
import * as schoolManagement from "./moudules/schoolManagement";
import * as dayWarning from './moudules/dayWarning';
import * as subjectComparison from './moudules/subjectComparison';
import * as publishedJobAnalysis from "./moudules/publishedJobAnalysis";
import * as survey from "./moudules/survey";
import * as feedback from "./moudules/feedback";
import * as dataComparison from "./moudules/dataComparison";

/*
 * 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 */
// 默认全部导出
export default {
  login,
  menu,
  authorityManagement,
  informationMaintenance,
  classManagement,
  memberManagement,
  roleManagement,
  subjectManagement,
  jobStatistics,
  schoolManagement,
  dayWarning,
  subjectComparison,
  publishedJobAnalysis,
  survey,
  feedback,
  dataComparison,
};



// WEBPACK FOOTER //
// ./src/http/api.js